import type { FC } from "react";
import { useEffect } from "react";
import { ContactFormNew } from "../components/pages/contact/ContactFormNew";
import { Layout } from "../layout/layout";

export const ContactForm: FC = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Layout>
      <main className="flex-grow bg-fy-blue">
        <ContactFormNew />
      </main>
    </Layout>
  );
};

export default ContactForm; 